import EmptyCurrencyIcon from './EmptyCurrencyIcon';

export default EmptyCurrencyIcon;
